import React, { useRef, useState } from 'react'
import { TextField, Button } from '@adobe/react-spectrum'
import BackButton from '../components/BackButton'
import { moveUserToCustomLicense } from '../api/database-api'

export default function Custom() {
  const [loading, setLoading] = useState()
  const emailRef = useRef()

  const onTransferClicked = async () => {
    const email = emailRef.current.getInputElement().value

    if (!email) {
      window.alert('Fill out the email address field.')
      return
    }

    setLoading(true)
    try {
      await moveUserToCustomLicense(email)
      window.alert('User moved to custom subscription successfully.')
      emailRef.current.getInputElement().value = ''
    } catch (error) {
      window.alert(error.message)
    }
    setLoading(false)
  }

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        justifyContent: 'flex-start',
        padding: 16,
        maxWidth: 400,
      }}
    >
      <BackButton />
      <span style={{ marginBottom: 8 }}>
        Move account to CUSTOM subscription.
      </span>
      <TextField ref={emailRef} label="Email address:" />
      <Button
        variant="cta"
        marginTop="size-200"
        marginBottom="size-300"
        isDisabled={loading}
        onPress={onTransferClicked}
      >
        Make Custom
      </Button>
    </div>
  )
}
